import { render, staticRenderFns } from "./creativeBaseset.vue?vue&type=template&id=0c68d56b&scoped=true&"
import script from "./creativeBaseset.vue?vue&type=script&lang=js&"
export * from "./creativeBaseset.vue?vue&type=script&lang=js&"
import style0 from "./creativeBaseset.vue?vue&type=style&index=0&id=0c68d56b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c68d56b",
  null
  
)

export default component.exports